import { Check } from "lucide-react";

const STEPS = [
  { id: 1, label: "Upload & Configure" },
  { id: 2, label: "Preview Changes" },
  { id: 3, label: "Download" },
];

export default function StepIndicator({ currentStep }) {
  return (
    <nav aria-label="Progress" data-testid="step-indicator">
      <ol className="flex items-center gap-3 sm:gap-6">
        {STEPS.map((s, idx) => {
          const isActive = s.id === currentStep;
          const isDone = s.id < currentStep;
          const isInactive = s.id > currentStep;
          return (
            <li key={s.id} className="flex items-center gap-3 sm:gap-6 flex-1 min-w-0">
              <div className="flex items-center gap-3 min-w-0">
                <span
                  data-testid={`step-badge-${s.id}`}
                  className={[
                    "inline-flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 font-brand-mono text-sm font-semibold shrink-0 transition-colors",
                    isActive && "bg-[#007d62] text-white",
                    isDone && "bg-[#0d0d0d] text-white",
                    isInactive && "bg-transparent border-2 border-[#0d0d0d]/25 text-[#96a09a]",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  {isDone ? <Check className="w-4 h-4" strokeWidth={3} /> : s.id}
                </span>
                <div className="min-w-0">
                  <div className="font-brand-mono text-[10px] uppercase tracking-[2px] text-[#96a09a] leading-none">
                    Step 0{s.id}
                  </div>
                  <div
                    className={[
                      "font-['Archivo'] font-extrabold text-sm sm:text-base uppercase tracking-wide leading-tight truncate mt-1",
                      isActive || isDone ? "text-[#0d0d0d]" : "text-[#96a09a]",
                    ].join(" ")}
                  >
                    {s.label}
                  </div>
                </div>
              </div>
              {idx < STEPS.length - 1 && (
                <span
                  className={[
                    "flex-1 h-[2px] hidden sm:block",
                    s.id < currentStep ? "bg-[#0d0d0d]" : "bg-[#0d0d0d]/15",
                  ].join(" ")}
                  aria-hidden="true"
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
